module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"TopCategories":{"heading":"Vyberte si z nejpopulárnějších kategorií"}},"en":{"TopCategories":{"heading":"Choose from the most popular categories"}}}')
  delete Component.options._Ctor
}
